export default {
  "menu": {
    "biocompatibility": "Biocompatibilidad",
    "truckSleeps": "Eventos de somnolencia",
    "conduct": "Conducta",
    "sheetOfLife": "Hoja de vida",
    "waitingTime": "Tiempos de espera",
    "assignment": "Asignación",
    "manager": "Gestionador",
    "dataManagement": "Gestión de datos",
    "compliance": "Cumplimiento",
    "ffdPvt": "Cognus",
    "ffdSleep": "Fitness for duty",
    "fleet": "Flota",
    "inspections": "Inspecciones",
    "reports": "Reportes"
  },
  "subMenu": {
    "summary": "Resumen",
    "detail": "Detalle",
    "driver": "Conductor",
    "listOfVehicule": "Listado de asignación",
    "drivers": "Conductores",
    "pendingAssociationDrivers": "Conductores Desconocidos",
    "team": "Equipos",
    "pendingAssociationTeam": "Equipos Desconocidos",
    "semiTrailer": "Ramplas",
    "pendingAssociationSemiTrailer": "Ramplas Desconocidas",
    "geozone": "Geozonas",
    "tag": "Categorías",
    "extendedProperty": "Atributos Adicionales",
    "configuration": "Configuración",
    "users": "Usuarios",
    "driverList": "Listado de checklist",
    "dynamicList": "Lista dinámica",
    "workingShiftGroup": "Grupos de turno",
    "results": "Resultados"
  },
  "taskManagerIndicators": {
    "open": "Desviaciones abiertas",
    "overdue": "Desviaciones vencidas"
  },
  "actions": {
    "expand": "Expandir menú",
    "collapse": "Contraer menú"
  },
  "reports": {
    "urlEmptyTitle": "Url no configurada",
    "urlEmpty": "No tienes una url configurada para visualizar los reportes.<br>Por favor contacta a la mesa de ayuda de Gauss Control.",
    "invalidUrlTitle": "Url inválida",
    "invalidUrl": "La url <b>{externalUrl}</b> no es válida.<br>Por favor contacta a la mesa de ayuda de Gauss Control."
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/escondida/nav/index.js